/* src/app/modules_v2/investment/financial-investment/components/financial-investment-form-dialog/financial-investment-form-dialog.component.scss */
.fif-layout {
  display: grid;
  grid-template-columns: minmax(0, 1.35fr) minmax(0, 1fr);
  gap: 24px;
}
.fif-main {
  min-width: 0;
}
.fif-aside {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.cf-dlg-section__label {
  display: flex;
  align-items: center;
  gap: 6px;
}
.fif-hint {
  margin: -8px 0 12px;
  font-size: 12px;
  color: #6b7280;
}
.fif-row-center {
  align-items: center;
}
.fif-field-help {
  display: flex;
  align-items: flex-start;
  gap: 6px;
}
.fif-field-help app-field {
  flex: 1;
  min-width: 0;
}
.fif-field-help app-help {
  margin-top: 16px;
  flex-shrink: 0;
}
.fif-toggle {
  display: flex;
  align-items: center;
  gap: 8px;
  padding-bottom: 18px;
}
.fif-doc-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px;
}
.fif-doc-actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}
.fif-file-input {
  display: none;
}
.fif-btn--danger:hover {
  color: #dc2626 !important;
  border-color: #fecaca !important;
}
.fif-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-height: 220px;
  padding: 16px;
  border: 1px dashed #e5e7eb;
  border-radius: 10px;
  color: #6b7280;
  font-size: 13px;
  text-align: center;
}
.fif-empty mat-icon {
  font-size: 32px;
  width: 32px;
  height: 32px;
  color: #cbd5e1;
}
.fif-preview {
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  overflow: hidden;
  background: #f8fafc;
}
.fif-preview img {
  display: block;
  max-width: 100%;
  max-height: 520px;
  margin: 0 auto;
  object-fit: contain;
}
.fif-preview iframe {
  display: block;
  width: 100%;
  height: 520px;
  border: 0;
}
@media (max-width: 860px) {
  .fif-layout {
    grid-template-columns: 1fr;
  }
}
/*# sourceMappingURL=financial-investment-form-dialog.component.css.map */
